var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.0469 38.5938L36.4062 21.9531L53.0469 5.3125L69.6875 21.9531L53.0469 38.5938ZM9.375 32.9688V9.45313H32.8906V32.9688H9.375ZM42.0312 65.625V42.1094H65.5469V65.625H42.0312ZM9.375 65.625V42.1094H32.8906V65.625H9.375ZM14.0625 28.2813H28.2031V14.1406H14.0625V28.2813ZM53.2812 32.2656L63.3594 22.1875L53.2812 12.1094L43.2031 22.1875L53.2812 32.2656ZM46.7187 60.9375H60.8594V46.7969H46.7187V60.9375ZM14.0625 60.9375H28.2031V46.7969H14.0625V60.9375Z",
    fill: "#4F3318"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlign);
export default __webpack_public_path__ + "static/media/align.be3459fc815dd4d2a9d108f72063133e.svg";
export { ForwardRef as ReactComponent };